import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Button, Row, Col, Typography } from 'antd';
import AddForm from '../components/AddForm';
import { useDispatch, useSelector } from 'react-redux';
import { getPurchaseOrderOption } from '../../ducks/actions'
import { addPurchaseOrder, generateInventoryNo } from "../../ducks/services"
import { useTranslate } from 'Translate';

const _ = require('lodash');
const { Title } = Typography;

export default (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [editable, setEditable] = useState(true);
  const meta = useSelector((state) => state.inventory.option);
  const i18n = useTranslate();
    const { t } = i18n;

  useEffect(() => {
    dispatch(getPurchaseOrderOption(props.setLoading));
  }, [])

  return (
    <Row gutter={[20, 30]}>
      <Col span={24} style={{ position: "sticky", top: "-30px", backgroundColor: "#f5f5f5", zIndex: 3, padding: "10px" }}>
        <Row justify={'space-between'} align={'middle'}>
          <Col flex='auto'>
            <Title level={3} className='mb-0 mt-0'>{t("New.purchase_order")}</Title>
          </Col>
          <Col flex='auto' className='text-right'>
            <Space size={10}>
              {
                editable && activeTab === "1" &&
                <Button size="large" htmlType='submit' className='green-btn text-white' form="po-details-form">{t("General.save")}</Button>
              }
              <Button size="large" htmlType='button' className='red-btn text-white' onClick={() => navigate('/inventory/purchase-order')}>{'<'} {t("General.back")}</Button>
            </Space>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <AddForm
          loading={props.loading}
          setLoading={props.setLoading}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          oneTab={true}
          mode={'add'}
          meta={meta}
          addPurchaseOrder={addPurchaseOrder}
          navigate={navigate}
          reloadApi={(propId) => navigate(`/inventory/purchase-order/${propId}?t=2`)}
          allowedEdit={true}
          generateInventoryNo={generateInventoryNo}
          editable={editable}
          setEditable={setEditable}
        />
      </Col>
    </Row>
  )
}